<script>
const columns = [
  {
    key: 'context',
    title: 'Context',
    scopedSlots: { customRender: 'context' }
  }, {
    key: 'context_property',
    title: 'Property',
    scopedSlots: { customRender: 'context_property' }
  }, {
    key: 'value',
    title: 'Value',
    width: 100,
    scopedSlots: { customRender: 'value' }
  }, {
    key: 'value_type',
    title: 'Value Type',
    scopedSlots: { customRender: 'value_type' }
  }, {
    key: 'operand',
    title: 'Operand',
    width: 350,
    scopedSlots: { customRender: 'operand' }
  }, {
    key: 'assertion',
    title: 'Assertion',
    scopedSlots: { customRender: 'assertion' }
  }, {
    key: 'action',
    title: 'Action',
    width: 100,
    align: 'right',
    scopedSlots: { customRender: 'action' }
  }
]
export default {
  props: {
    product: {
      type: String,
      required: true
    },
    billerProduct: {
      type: String,
      required: true
    }
  },
  data: () => ({
    rowEdit: null,
    cachedRow: {},
    columns,
    loading: false,
    item: {},
    dataset: {
      logical: [],
      operand: [],
      datatype: [],
      contexts: {}
    },
    patching: []
  }),
  created() {
    this.getConfigData()
    this.getItem()
  },
  methods: {
    append() {
      let items = [...this.item.items]
      const newRuleItem = {
        hash: 'xxxxxx',
        context: null,
        context_property: null,
        operand: null,
        value: null,
        value_type: 'string',
        assertion: true,
        newItem: true
      }
      items.unshift(newRuleItem)
      this.item.items = items
      this.editRow(newRuleItem.hash)
    },
    editRow(hash) {
      const items = [...this.item.items]
      const target = items.filter(item => hash === item.hash)[0]
      this.rowEdit = hash

      if (target) {
        this.cachedRow = { ...target }
        target.editable = true
        this.item.items = items
      }
    },
    updateRow(record) {
      this.patching.push(record.hash)

      if (record.newItem) this.store(record)
      else this.update(record)
    },
    store(record) {
      this.$http.post(this.routeUri('hyperion.rule.item.store', { rule_hash: this.item.hash }), record)
        .then((res) => this.reload())
        .catch((err) => this.handleXhrError(err))
    },
    update(record) {
      this.$http.put(this.routeUri('hyperion.rule.item.update', { rule_hash: this.item.hash, rule_item_hash: record.hash }), record)
        .then((res) => this.reload())
        .catch((err) => this.handleXhrError(err))
    },
    destroy(record) {
      this.patching.push(record.hash)
      this.$http.delete(this.routeUri('hyperion.rule.item.destroy', { rule_hash: this.item.hash, rule_item_hash: record.hash }))
        .then((res) => this.reload())
        .catch((err) => this.handleXhrError(err))
    },
    reload() {
      this.patching = []
      this.$notification.success({
        message: "Success",
        description: "Data has been successfully updated!",
        onClose: () => window.location.reload()
      });
    },
    cancel(hash) {
      const items = [...this.item.items]
      let target = items.filter(item => hash === item.hash)[0]
      this.rowEdit = null
      if (target) {
        if (target.hasOwnProperty('newItem')) {
          delete target.newItem
          items.shift()
        } else {
          target = { ... this.cachedRow }
          delete target.editable
          this.cachedRow = null
        }
      }

      this.item.items = items
    },
    getConfigData() {
        this.$http.get(this.routeUri('hyperion.rule.dataset'), {
          params: {
            dataset: 'all'
          }
        })
      .then((res) => this.dataset = res.data)
      .catch((error) => this.handleXhrError(error))
    },
    getItem() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.product.biller.rule', {
        product_hash: this.product,
        biller_product_uuid: this.billerProduct
      }))
        .then((res) => this.item = res.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    getContextProperties(context) {
      return this.dataset.contexts[context] ?? []
    }
  }
}
</script>
<template>
  <a-row :gutter="16">
    <a-col :span="18">
      <a-card size="small" type="inner">
        <div class="text-right" style="margin-bottom: 24px;">
          <a-button size="small" icon="plus" @click="append">Create</a-button>
        </div>
        <a-skeleton :loading="loading" active>
          <a-table :columns="columns" :dataSource="item.items" :pagination="false" rowKey="hash">
            <div slot="context" slot-scope="record">
                <template v-if="record.editable">
                  <a-select show-search v-model="record.context" style="width: 100%;">
                    <a-select-option v-for="(properties, index) in dataset.contexts" :value="index" :key="`context-${index}`">{{ index }}</a-select-option>
                  </a-select>
                </template>
                <template v-else>
                  <h4><code>{{ record.context }}</code></h4>
                </template>
            </div>
            <div slot="context_property" slot-scope="record">
              <template v-if="record.editable">
                <a-select show-search v-model="record.context_property" style="width: 100%;">
                  <a-select-option v-for="(value, index) in getContextProperties(record.context)" :value="index" :key="`cp-${index}`"><code>{{ index }}:{{ value }}</code></a-select-option>
                </a-select>
              </template>
              <template v-else>
                <h4><code>{{ record.context_property }}</code></h4>
              </template>
            </div>
            <div slot="value" slot-scope="record">
              <template v-if="record.editable">
                <a-input v-model="record.value" />
              </template>
              <template v-else>
                <h4><code>{{ record.value }}</code></h4>
              </template>
            </div>
            <div slot="value_type" slot-scope="record">
              <template v-if="record.editable">
                <a-select show-search v-model="record.value_type" style="width: 100%;">
                  <a-select-option v-for="(value, index) in dataset.datatype" :value="value" :key="`vt-${index}`"><code>{{ value }}</code></a-select-option>
                </a-select>
              </template>
              <template v-else>
                <h4><code>{{ record.value_type }}</code></h4>
              </template>
            </div>

            <div slot="operand" slot-scope="record">
              <template v-if="record.editable">
                <a-select show-search v-model="record.operand" style="width: 100%;">
                  <a-select-option v-for="(value, index) in dataset.operand" :value="value"  :key="`opr-${index}`"><code>{{ value }}</code></a-select-option>
                </a-select>
              </template>
              <template v-else>
                <h4><code>{{ record.operand }}</code></h4>
              </template>
            </div>

            <div slot="assertion" slot-scope="record">
              <template v-if="record.editable">
                <a-radio-group v-model="record.assertion">
                  <a-radio-button :value="true">True</a-radio-button>
                  <a-radio-button :value="false">False</a-radio-button>
                </a-radio-group>
              </template>
              <template v-else>
                <h4><code>{{ record.assertion }}</code></h4>
              </template>
            </div>

            <div slot="action" slot-scope="record">
              <template v-if="record.editable">
                <a-button :loading="patching.includes(record.hash)" @click="() => updateRow(record)" icon="save" size="small" />
                <a-popconfirm title="Sure to cancel?" @confirm="() => cancel(record.hash)">
                  <a-button :loading="patching.includes(record.hash)" type="danger" size="small" icon="stop" />
                </a-popconfirm>
              </template>
              <template v-else>
                <a-button :disabled="rowEdit !== null" @click="() => editRow(record.hash)" type="primary" icon="edit" size="small" />
                <a-popconfirm
                  title="Sure to delete?"
                  @confirm="() => destroy(record)">
                  <a-button :disabled="rowEdit !== null" type="danger" size="small" icon="delete" />
                </a-popconfirm>
              </template>
            </div>
          </a-table>
        </a-skeleton>
      </a-card>
    </a-col>
    <a-col :span="6">
      <a-card size="small" type="inner">
        <a-skeleton :loading="loading" active>
          <a-form-model layout="vertical" :model="item">
            <a-form-model-item label="Is Active">
              <a-switch v-model="item.is_active" />
            </a-form-model-item>

            <a-divider dashed />
            <a-form-model-item label="Assertion">
              <a-radio-group v-model="item.assertion">
                <a-radio-button :value="true">True</a-radio-button>
                <a-radio-button :value="false">False</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <a-divider dashed />
            <a-form-model-item label="Logical Operator">
              <a-radio-group v-model="item.operator">
                <a-radio value="AND"><strong><code>AND : </code></strong> - All condition must be {{ item.assertion ? '`true`' : '`false`'}}</a-radio>
                <a-radio value="OR"><strong><code>OR &nbsp;: </code></strong> - One or more condition is {{ item.assertion ? '`true`' : '`false`'}}</a-radio>
                <a-radio value="NOT"><strong><code>NOT : </code></strong> - All condition must be {{ item.assertion ? '`true`' : '`false`'}}</a-radio>
                <a-radio value="XOR"><strong><code>XOR : </code></strong> - Only one condition is {{ item.assertion ? '`true`' : '`false`'}}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-form-model>
        </a-skeleton>
      </a-card>
    </a-col>
  </a-row>
</template>
